import React from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Label,
    Icon, Form, Dropdown, Table, Popup, Card, Placeholder, Divider, Tab, Loader
} from 'semantic-ui-react';
import download from 'downloadjs';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import SimpleStatisticTable from './SimpleStatisticTable';
import SimpleOptionsAnswersWithCommentTable from './SimpleOptionsAnswersWithCommentTable';
import AverageTableWithReportButton from './AverageTableWithReportButton';


// eslint-disable-next-line react/require-render-return
export default class SectionTemplate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            answers: [],
            averageForQuestionnaire: '',
            loading: true,

            QuestionList: [{
                questionText: 'pitane?',
                answers: [1, 2, 3, 5],
                averagePerQuestion: 2.6,
                questionOptions: ['opt1', 'opt2', 'opt3', 'opt4'],
                questionComments: ['comment1', 'comment2']
            }, {
                questionText: 'pitane?',
                answers: [1, 2, 3, 5],
                averagePerQuestion: 2.6,
                questionOptions: ['opt1', 'opt2', 'opt3', 'opt4'],
                questionComments: ['comment1', 'comment2', 'comment2', 'comment2', 'comment2', 'comment2']
            }],
        };
        // this.getAllPollData = this.getAllPollData.bind(this);
        this.getPollAnswersForSection = this.getPollAnswersForSection.bind(this);
    }
    UNSAFE_componentWillMount() {
        this.getPollAnswersForSection(JSON.parse(localStorage.getItem('poll')).pollId, this.props.sectionId);
    }
    getPollAnswersForSection(pollId, sectionId) {
        let obj = {
            courseImplementationGroup: JSON.parse(localStorage.getItem('poll')).pollTypeKey !== 'study program evaluation' ? parseInt(localStorage.getItem('courseImplementationGroupId'), 10) ? { id: parseInt(localStorage.getItem('courseImplementationGroupId'), 10) } : null : null,
            courseImplementation: localStorage.getItem('courseId') ? { id: localStorage.getItem('courseId') } : null,
            studyProgram: localStorage.getItem('spId') ? { id: localStorage.getItem('spId') } : null,
            organizationalUnitEmployee: JSON.parse(localStorage.getItem('poll')).pollTypeKey !== 'study program evaluation' ? { id: parseInt(localStorage.getItem('organizationalUnitEmployeeId'), 10) } : null
        };

        axios.post(`/questionnaire/statistics/${pollId}/${sectionId}/`, { ...obj })
            .then(res => {
                let answers = res.data;// o staff

                this.setState({
                    answers: answers.questionDTOS,
                    averageForQuestionnaire: answers.averageForQuestionnaire,
                    loading: false
                });
            }).catch(err => {
                this.setState({
                    answers: [],
                    loading: false
                });
                console.log('Failed to fetch poll data for section.');
            });
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }


    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        this.setState({ loading: true });
        console.log(nextProps);
        console.log(nextContext);
        let { sectionId } = nextProps;
        this.getPollAnswersForSection(JSON.parse(localStorage.getItem('poll')).pollId, sectionId);
    }

    render() {
        return (

            <div>

                {/* <SimpleStatisticTable */}
                {/*    questionList={this.state.QuestionList} */}
                {/*    tableRibbonLabel="Broj studenata koji su odg pitanja" */}
                {/*    buttonReport */}
                {/*    buttonReportText="Izvještaj" */}
                {/*    graphically */}
                {/*    tableHeader */}
                {/*    questionOptions={['Ocjena 1', 'Ocjena 2', 'Ocjena 3', 'Ocjena 4']} */}
                {/*    averageForQuestionnaire={4.2} */}

                {/* /> */}

                {/* <br /> */}

                {this.state.loading ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div> :
                    <div>

                    <br />
                    <SimpleOptionsAnswersWithCommentTable
                            questionList={this.state.answers}
                            tableRibbonLabel="Broj studenata koji su odg pitanja"
                            buttonReport
                            buttonReportText="Generiši izvještaj"
                            comment
                        />
                </div>


                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/ProfessorPoll/SectionTemplate.js